<template>
  <div>
 <base-header v-once pageName="공지사항" :popup="true"></base-header>
      <section id="wrap">
        <div class="notice-Detail">
          <div>
            <i>{{importance === '1' ? '긴급' : '일반'}}</i>
            <em>{{writeDate}}</em>
            <p>{{title}}</p>
          </div>
          
          <article v-html="crossDocLocation">
            
          </article>

          <p class="file">
            <button type="button" @click="goDownSite(item.fileDownUrl)" v-for="item in fileList" v-bind:key="item.fileDownUrl">
            {{item.fileName}}</button>
          </p>
        </div>
      </section>
      <div class="btnWrap">
        <button type="button" class="black" @click="close">목록</button>
      </div>
  </div>
</template>

<script>
var parser = new DOMParser();
export default {
	data() {
		return{
      title :'',
      importance:'',
      writeDate:'',
      crossDocLocation:'',
      fileName:'',
      fileDownUrl:'',
      fileList:[]
		};
	},
  methods: {
    close: function() {
       var child = {
            name: 'popup-close',
            data: {
                routerName : 'notice-list',
            }
        }
        this.$utils.nativeIf.outbound.sendChildData(child);
    },
    downfile: function(fileDownUrl) {
        this.$utils.nativeIf.outbound.newPage(fileDownUrl)  //새창 띄우기
    },

    goDownSite(url){
      this.$utils.nativeIf.outbound.outlink(encodeURI(url))        
    },

  },
  created : function(){
      var that = this;
      var parameters = {
        'itemId': this.$route.query.itemId
      };
    this.$api.notice
    .detail(parameters)
    .then(function(data) {
        if(data){
          that.title = parser.parseFromString(data.title, "text/html").body.innerText;
          that.crossDocLocation = data.crossDocLocation;
          that.writeDate = data.writeDate;
          that.importance = data.importance;
          that.fileList = data.fileList;

        }
      })
      .catch(function(error) {
        alert(error.rtMsg);
        that.$utils.nativeIf.outbound.close(false);
      });
    
  }
};
</script>
